import qs from "qs";

import firstParam from "../firstParam";

export const CREATE_PRICE_ALERT_PARAM = "createPriceAlert";
export const CREATE_PRICE_ALERT_STOCK_ID_PARAM = "stockId";
export const CREATE_PRICE_ALERT_PRICE_PARAM = "price";
export const CREATE_PRICE_ALERT_COMMENT_PARAM = "comment";

export const CREATE_PRICE_ALERT_INTENT_TYPE = {
  INVALID: "invalid",
  OPEN: "open"
};

const TRUTHY_CREATE_PRICE_ALERT_VALUES = new Set(["1", "true", true]);

export function isCreatePriceAlertRequested(searchParams = {}) {
  const value = firstParam(
    searchParams[CREATE_PRICE_ALERT_PARAM]
  );

  return TRUTHY_CREATE_PRICE_ALERT_VALUES.has(value);
}

export function parseCreatePriceAlertSearch(search) {
  const searchParams = qs.parse(search, { ignoreQueryPrefix: true });

  if (!isCreatePriceAlertRequested(searchParams)) {
    return null;
  }

  return {
    stockId: firstParam(searchParams[CREATE_PRICE_ALERT_STOCK_ID_PARAM]),
    price: firstParam(searchParams[CREATE_PRICE_ALERT_PRICE_PARAM]),
    comment: firstParam(searchParams[CREATE_PRICE_ALERT_COMMENT_PARAM]),
    searchParams
  };
}

export function stripCreatePriceAlertParams(searchParams = {}) {
  const nextParams = { ...searchParams };

  delete nextParams[CREATE_PRICE_ALERT_PARAM];
  delete nextParams[CREATE_PRICE_ALERT_STOCK_ID_PARAM];
  delete nextParams[CREATE_PRICE_ALERT_PRICE_PARAM];
  delete nextParams[CREATE_PRICE_ALERT_COMMENT_PARAM];

  return nextParams;
}

export function buildCreatePriceAlertSearch({
  stockId,
  price,
  comment
} = {}) {
  const params = {
    [CREATE_PRICE_ALERT_PARAM]: "1"
  };

  if (stockId != null && stockId !== "") {
    params[CREATE_PRICE_ALERT_STOCK_ID_PARAM] = String(stockId);
  }

  if (price != null && price !== "") {
    params[CREATE_PRICE_ALERT_PRICE_PARAM] = String(price);
  }

  if (comment) {
    params[CREATE_PRICE_ALERT_COMMENT_PARAM] = comment;
  }

  return qs.stringify(params, { addQueryPrefix: true });
}

export function resolveCreatePriceAlertIntent({ search }) {
  const parsed = parseCreatePriceAlertSearch(search);

  if (!parsed) {
    return null;
  }

  const stockId = parsed.stockId;

  if (!stockId) {
    return {
      type: CREATE_PRICE_ALERT_INTENT_TYPE.INVALID,
      searchParams: parsed.searchParams
    };
  }

  return {
    type: CREATE_PRICE_ALERT_INTENT_TYPE.OPEN,
    stockId: String(stockId),
    price: parsed.price,
    comment: parsed.comment,
    searchParams: parsed.searchParams
  };
}
